import { useEffect, useState } from "react";
import { AdminLayout } from "@/components/AdminLayout";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";

export default function AdminSugestoes() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  
  useEffect(() => {
    const params = {}; if (filter && filter !== "all") params.status = filter;
    api.get("/suggestions", { params }).then(r => setItems(r.data || [])).catch(() => {});
  }, [filter]);
  
  const load = () => {
    const params = {}; if (filter && filter !== "all") params.status = filter;
    api.get("/suggestions", { params }).then(r => setItems(r.data || [])).catch(() => {});
  };

  const setStatus = async (id, status) => {
    try {
      await api.put(`/admin/suggestions/${id}`, { status });
      toast.success("Status atualizado");
      load();
    } catch { toast.error("Erro"); }
  };

  return (
    <AdminLayout title="Sugestões de cursos">
      <Card className="rounded-xl"><CardContent className="p-4 flex gap-3 items-end">
        <div className="flex-1"><p className="text-xs text-muted-foreground mb-1">Filtrar por status</p>
          <Select value={filter} onValueChange={setFilter}>
            <SelectTrigger className="w-[220px]"><SelectValue placeholder="Todos" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos</SelectItem>
              <SelectItem value="em_votacao">Em votação</SelectItem>
              <SelectItem value="aprovado">Aprovado</SelectItem>
              <SelectItem value="lancado">Lançado</SelectItem>
              <SelectItem value="rejeitado">Rejeitado</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardContent></Card>
      <Card className="rounded-xl mt-4"><CardContent className="p-0 overflow-x-auto">
        <Table><TableHeader><TableRow>
          <TableHead>Título</TableHead><TableHead>Área</TableHead><TableHead>Votos</TableHead><TableHead>Autor</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Ação</TableHead>
        </TableRow></TableHeader>
          <TableBody>
            {items.map(s => (
              <TableRow key={s.id}>
                <TableCell><p className="font-medium">{s.title}</p><p className="text-xs text-muted-foreground line-clamp-1">{s.description}</p></TableCell>
                <TableCell><Badge variant="secondary" className="capitalize">{s.area}</Badge></TableCell>
                <TableCell>{s.votes}</TableCell>
                <TableCell className="text-xs">{s.user_name}</TableCell>
                <TableCell><Badge variant="outline" className="capitalize">{s.status.replace("_", " ")}</Badge></TableCell>
                <TableCell className="text-right">
                  <Select value={s.status} onValueChange={(v) => setStatus(s.id, v)}>
                    <SelectTrigger className="w-[160px]" data-testid={`sug-status-${s.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="em_votacao">Em votação</SelectItem>
                      <SelectItem value="aprovado">Aprovar</SelectItem>
                      <SelectItem value="lancado">Lançado</SelectItem>
                      <SelectItem value="rejeitado">Rejeitar</SelectItem>
                    </SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={6} className="py-10 text-center text-sm text-muted-foreground">Nenhuma sugestão</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>
    </AdminLayout>
  );
}
